import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-[80vh] bg-[#050505] flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center bg-[#0d0d0d] border border-white/10 rounded-2xl p-10">
        <XCircle className="text-white/50 mx-auto" size={52} />
        <h1 className="text-white font-display text-2xl mt-5">Pagamento annullato</h1>
        <p className="text-white/60 mt-3">Nessun addebito effettuato. Il tuo carrello è ancora salvato.</p>
        <Link to="/" className="mt-7 inline-block bg-red-600 hover:bg-red-500 text-white font-cond tracking-wide px-6 py-3 rounded-lg">Torna al sito</Link>
      </div>
    </div>
  );
}
